import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import { API_BASE } from '../../config/api';
import { FaCalendarAlt, FaUser } from 'react-icons/fa';
import './css/BlogsPage.css';

const BlogsPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${API_BASE}/api/blog`)
      .then((res) => setPosts(res.data.posts || []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('ar-EG', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const imageUrl = (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    return `${API_BASE}${path}`;
  };

  return (
    <div className="blogs-page" dir="rtl">
      <header className="blogs-header">
        <div className="container relative-z">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            المدونة
          </motion.h1>
          <p>مقالات ونصائح من د. نهى الحازمي</p>
        </div>
      </header>

      <section className="blogs-content">
        <div className="container">
          {loading && <p className="blogs-loading">جاري تحميل المنشورات...</p>}
          {error && <p className="blogs-error">حدث خطأ في التحميل. يرجى المحاولة لاحقًا.</p>}
          {!loading && !error && posts.length === 0 && (
            <p className="blogs-empty">لا توجد منشورات حتى الآن.</p>
          )}
          {!loading && !error && posts.length > 0 && (
            <div className="blogs-grid">
              {posts.map((post, i) => (
                <motion.article
                  key={post.id}
                  className="blog-card"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                >
                  <Link to={`/blog/${post.slug}`} className="blog-card-link">
                    <div className="blog-card-image">
                      {imageUrl(post.featured_image) ? (
                        <img src={imageUrl(post.featured_image)} alt={post.title} />
                      ) : (
                        <div className="blog-card-placeholder" />
                      )}
                    </div>
                    <div className="blog-card-body">
                      <h2 className="blog-card-title">{post.title}</h2>
                      {post.excerpt && <p className="blog-card-excerpt">{post.excerpt}</p>}
                      <div className="blog-card-meta">
                        <span><FaUser /> {post.author}</span>
                        <span><FaCalendarAlt /> {formatDate(post.created_at)}</span>
                      </div>
                    </div>
                  </Link>
                </motion.article>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default BlogsPage;
